<template>
  <div class="background-color-white px-5 pb-3" id="keep-search">
    <Title
      :category="product.categories[0]"
      :department="product.parent_categories[0]"
      class="pl-0"
    />
    <RouteBack />
    <SurgeonGeneralsWarning
      v-if="product.tobacco_warning"
      :text="product.tobacco_warning"
    />
    <AlcoholProductsRequireIdWarning v-if="product.is_alcohol" />
    <v-container>
      <v-row class="pt-1">
        <v-col
          cols="12"
          class="d-flex justify-center overflow-hidden position-relative"
        >
          <CornerRibbon
            v-if="
              (product.pricebook_info.promotions &&
                product.pricebook_info.promotions.length) ||
              product.new_product
            "
            :newItem="
              !(
                product.pricebook_info.promotions &&
                product.pricebook_info.promotions.length
              )
            "
            large
          />
          <div class="align-center d-flex justify-center position-relative">
            <FavoriteIcon
              :upc="product.upc"
              class="favorite-button-position"
              mobile
            />
            <img
              v-if="product.image"
              :alt="product.name"
              :src="product.image"
              class="product-image-size-sm mt-2"
            />
            <NoImageAvailable
              v-else
              :departmentName="
                getProductDepartmentName(
                  product.parent_categories,
                  product.categories,
                )
              "
              :size="'sm'"
            />
          </div>
        </v-col>
        <v-col cols="12">
          <span class="font-size-lg font-weight-semibold">{{
            product.name
          }}</span>
          <span class="color-suva-grey">
            <br />
            {{ product.brand }}
          </span>
          <UnitSizeDisplay
            :baseSize="product.base_size"
            :size="product.size"
            :uom="product.uom"
          />
          <v-row>
            <v-col>
              <UnitPriceDisplay
                :byweight="product.byweight"
                :type="'generic'"
                :unitPrice="product.cents"
                :redeemable="product.redeemable"
                :points="product.redemption_points_offer"
              />
            </v-col>
          </v-row>
          <v-row align="center">
            <v-col cols="5">
              <CartQuantityButton
                :cartProduct="product"
                :quantityType="'cartQty'"
              />
            </v-col>
            <v-col cols="7">
              <TermsList
                v-if="
                  product.pricebook_info.promotions &&
                  product.pricebook_info.promotions.length
                "
                :byweight="product.byweight"
                :promotions="product.pricebook_info.promotions"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <div
                class="color-suva-grey font-size-sm position-relative"
                :class="
                  product.is_tobacco || product.is_alcohol
                    ? 'visible'
                    : 'hidden'
                "
              >
                <AlcoholWarning v-if="product.is_alcohol" xs />
                <TobaccoWarning v-if="product.is_tobacco" xs />
              </div>
            </v-col>
          </v-row>
          <v-row
            v-if="hasTieredDiscount"
            class="font-size-xs grey--text justify-center"
          >
            *Tiered discounts cannot be combined with the other tiered discounts
            for this item.
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { getProductDepartmentName } from "@/util.js";
import AlcoholProductsRequireIdWarning from "@/elements/AlcoholProductsRequireIdWarning.vue";
import AlcoholWarning from "@/components/Product/AlcoholWarning.vue";
import CartQuantityButton from "@/components/Product/CartQuantityButton.vue";
import FavoriteIcon from "@/components/Product/FavoriteIcon.vue";
import NoImageAvailable from "@/components/Product/NoImageAvailable.vue";
import CornerRibbon from "@/components/Product/Promotions/CornerRibbon.vue";
import RouteBack from "@/components/UI/RouteBack.vue";
import SurgeonGeneralsWarning from "@/components/UI/SurgeonGeneralsWarning.vue";
import TermsList from "@/components/Product/Promotions/Terms/List.vue";
import Title from "@/components/Product/Title.vue";
import TobaccoWarning from "@/components/Product/TobaccoWarning.vue";
import UnitPriceDisplay from "@/components/Product/UnitPriceDisplay.vue";
import UnitSizeDisplay from "@/components/Product/UnitSizeDisplay.vue";
import { mapGetters } from "vuex";

export default {
  name: "ProductDetailsView",
  components: {
    AlcoholProductsRequireIdWarning,
    AlcoholWarning,
    CartQuantityButton,
    FavoriteIcon,
    NoImageAvailable,
    CornerRibbon,
    RouteBack,
    SurgeonGeneralsWarning,
    TermsList,
    Title,
    TobaccoWarning,
    UnitPriceDisplay,
    UnitSizeDisplay,
  },
  computed: {
    ...mapGetters({
      hasTieredDiscount: "product/hasTieredDiscount",
    }),
  },
  methods: {
    getProductDepartmentName,
  },
  props: { product: Object },
};
</script>

<style scoped>
.favorite-button-position {
  position: absolute;
  top: 0;
  left: -50px;
}
</style>
